import React, { useState } from "react";
import Slider from "react-slick";
import { useTheme, useMediaQuery } from "@mui/material";

import {
  Container as ContainerMUI,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useLocation } from "react-router-dom";

import { Box, Stack } from "@mui/material";

export const Container = ({
  children,
  maxWidth = "md",
  loading,
  imgs = [],
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isDragging, setIsDragging] = useState(false);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    beforeChange: () => setIsDragging(true),
    afterChange: () => setIsDragging(false),
  };

  return (
    <>
      <ContainerMUI disableGutters maxWidth={false}>
        <Stack
          sx={{
            width: "100%",
            minHeight: { xs: "auto", sm: "auto" },
          }}
        >
          {isMobile ? (
            // Mobile view - vertical banners
            <Stack spacing={2}>
              {imgs.map((item, idx) => (
                idx === 0 ? (
                  <Box key={item} onClick={() => !isDragging && props.onClienteClick()} style={{ cursor: 'pointer' }}>
                    <img src={item} alt="Banner" style={{ width: "100%" }} />
                  </Box>
                ) : (
                  <Box key={item}>
                    <a href={process.env.REACT_APP_SW_PRO_REGISTER_URL} target="_blank" rel="noopener noreferrer">
                      <img src={item} alt="Banner" style={{ width: "100%" }} />
                    </a>
                  </Box>
                )
              ))}
            </Stack>
          ) : (
            // Desktop view - slider
            <Slider {...settings}>
              {imgs.map((item, idx) => (
                idx === 0 ? (
                  <Box key={item} onClick={() => !isDragging && props.onClienteClick()} style={{ cursor: 'pointer' }}>
                    <img src={item} alt="Banner" style={{ width: "100%" }} />
                  </Box>
                ) : (
                  <Box key={item}>
                    <a href={process.env.REACT_APP_SW_PRO_REGISTER_URL} target="_blank" rel="noopener noreferrer">
                      <img src={item} alt="Banner" style={{ width: "100%" }} />
                    </a>
                  </Box>
                )
              ))}
            </Slider>
          )}
        </Stack>
      </ContainerMUI>

      <ContainerMUI disableGutters maxWidth={maxWidth} {...props}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {children}
      </ContainerMUI>
    </>
  );
};
